export const licenseData = [
  {
    featureName: 'ACT-NUM-AGENTS',
    displayName: 'Number of Agents',
    description: 'Number of online managed agents supported by the system'
  },
  {
    featureName: 'ACT-WEB',
    displayName: 'Web Transaction',
    description: 'Enables Web Transaction tests on the system'
  },
  {
    featureName: 'ACT-KAFKA-STREAMING-DB',
    displayName: 'KAFKA Streaming DB I/F',
    description: 'Enables streaming DB interface using KAFKA'
  },
  {
    featureName: 'ACT-NUM-USERS',
    displayName: 'Number of Users',
    description: 'Number of concurrent users logged into the system'
  },
  {
    featureName: 'ACT-MAINTENANCE',
    displayName: 'Annual Maintenance',
    description: 'Annual maintenance license. The system cannot be upgraded if expired'
  },
  {
    featureName: 'ACT-BASE-GIGA',
    displayName: 'ACT-BASE-GIGA',
    description: 'Base License for Gigatest'
  },
  {
    featureName: 'ACT-NUM-SW-AGENTS',
    displayName: 'Number of Software Agents',
    description: 'Number of online managed virtual software agents supported by the system'
  },
  {
    featureName: 'ACT-NUM-FLOWS',
    displayName: 'Number of Flows',
    description: 'Number of flows that all agents can concurrently run'
  },
  {
    featureName: 'ACT-AGGR-BW',
    displayName: 'Aggregate Bandwidth',
    description: 'Number of concurrent, aggregate test bandwidth supported by the system'
  },
  {
    featureName: 'ACT-TRUESPEED-SW-AGENT',
    displayName: 'TrueSpeed Test',
    description: 'Enables L4 RFC6349 / TrueSpeed test features on the system'
  },
  {
    featureName: 'ACT-TWAMP-SW-AGENT',
    displayName: 'TWAMP Test',
    description: 'Enables TWAMP PM features on the system'
  },
  {
    featureName: 'ACT-SVC-TEST-SW-AGENT',
    displayName: 'Services Test',
    description: 'Enables Services test features on the system'
  },
  {
    featureName: 'ACT-NUM-RPI',
    displayName: 'Number of Raspberry Pi Agents',
    description: 'Number of online managed Raspberry Pi agents supported by the system'
  },
  {
    featureName: 'EAX-NUM-TESTS',
    displayName: 'Number of Tests',
    description: '(incremental) number of concurrent tests supported on controller/collector'
  },
  {
    featureName: 'EAX-MAINTENANCE',
    displayName: 'Maintenance Contract',
    description: 'SW maintenance contract for controller, collector and SW agents'
  },
  {
    featureName: 'EAX-MB-AGGR-BW',
    displayName: 'Aggregate Bandwidth',
    description:
      '(incremental) number of concurrent, aggregate test bandwidth supported on controller/collector'
  },
  {
    featureName: 'EAX-NETCONF',
    displayName: 'NETCONF Support',
    description: 'enables NETCONF/YANG support on controller/collector'
  },
  {
    featureName: 'EAX-NUM-FLOWS',
    displayName: 'Maximum Number of Flows',
    description: '(incremental) maximum number of PM flows supported on controller/collector'
  },
  {
    featureName: 'EAX-NUM-USERS',
    displayName: 'Number of Users',
    description: '(incremental) number of concurrent users logging into the controller/collector'
  },
  {
    featureName: 'EAX-TS-MA',
    displayName: 'TrueSpeed Virtual Probe',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-TS-MTS-TBERD',
    displayName: 'TrueSpeed MTS TBERD',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for TBERD/MTS as test point(s)'
  },
  {
    featureName: 'EAX-TS-ONX',
    displayName: 'TrueSpeed ONX',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for ONX series as test point(s)'
  },

  {
    featureName: 'EAX-TS-PC-CLIENT',
    displayName: 'TrueSpeed PC Client',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for PC SW client as test point(s)'
  },
  {
    featureName: 'EAX-TS-WIFI-ADVISOR',
    displayName: 'TrueSpeed WiFi Advisor',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for WiFi Advisor as test point(s)'
  },
  {
    featureName: 'EAX-TWAMP-MA',
    displayName: 'TWAMP',
    description:
      'enables TWAMP PM feature(s) on controller/collector for virtual PM agents as test point(s)'
  },
  {
    featureName: 'EAX-Y1564-MTS-TBERD',
    displayName: 'Y1564 MTS TBERD',
    description:
      'enables Y1564 L3 test feature(s) on controller/collector for TBERD/MTS as test point(s)'
  },
  {
    featureName: 'EAX-Y1564-MA',
    displayName: 'Y1564',
    description:
      'enables Y.1564 L2/L3 test feature(s) on controller/collector for virtual test agents and loop back as test point(s)'
  },
  {
    featureName: 'EAX-UDP-MA',
    displayName: 'UDP',
    description:
      'enables L4 UDP test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-UDP-PC-CLIENT',
    displayName: 'UDP PC Client',
    description:
      'enables L4 UDP test feature(s) on controller/collector for PC SW client as test point(s)'
  },
  {
    featureName: 'EAX-LDAP',
    displayName: 'LDAP',
    description: 'enables LDAP support on controller/collector'
  },
  {
    featureName: 'EAX-TRUESPEED-QT600',
    displayName: 'TrueSpeed QT-600-10',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for QT-600-10 as test point(s)'
  },
  {
    featureName: 'EAX-Y1564-TBERD-MTS',
    displayName: 'Y1564 MTS TBERD',
    description:
      'enables Y1564 L3 test feature(s) on controller/collector for TBERD/MTS as test point(s)'
  },
  {
    featureName: 'EAX-KAFKA-STREAMING-DB',
    displayName: 'KAFKA Streaming DB I/F',
    description: 'enables streaming DB interface using KAFKA'
  },
  {
    featureName: 'EAX-REG-VTA',
    displayName: 'Number of vTA/vTA-TS',
    description:
      '(incremental) number of concurrent vTA/vTA-TS agents that can register with the controller/collector'
  },
  {
    featureName: 'EAX-REG-VPMA',
    displayName: 'Number of vPMA',
    description:
      '(incremental) number of concurrent vPMA agents that can register with the controller/collector (each agent 500 TWAMP flows or 100 Y.1731 streams as Initiator)'
  },
  {
    featureName: 'EAX-REG-TBMTS5800-V2',
    displayName: 'Number of T-BERD/MTS-5800',
    description:
      '(incremental) number of concurrent T-BERD/MTS-5800 family of handheld instruments that can register with the controller/collector'
  },
  {
    featureName: 'EAX-REG-TBMTS5800-100G',
    displayName: 'Number of T-BERD/MTS-5800-100G',
    description:
      '(incremental) number of concurrent T-BERD/MTS-5800-100G family of handheld instruments that can register with the controller/collector'
  },
  {
    featureName: 'EAX-REG-QT600-10G',
    displayName: 'Number of QT-600-10G',
    description:
      '(incremental) number of concurrent QT-600-10G probes that can register with the controller/collector'
  },
  {
    featureName: 'EAX-OVERLAY-TWAMP-MESH',
    displayName: 'Overlays/UI for MESH Setup of PM flows',
    description: 'enables mass/bulk edit and easy setup of PM flows via UI (MESH Configuration)'
  },
  {
    featureName: 'EAX-TWAMP-QT600',
    displayName: 'TWAMP for QT-600-10',
    description:
      'enables TWAMP PM feature(s) on controller/collector for QT-600-10 as test point(s)'
  },
  {
    featureName: 'EAX-Y1731-MA',
    displayName: 'Y.1731',
    description:
      'enables Y1731 PM feature(s) on controller/collector for virtual PM agents as test point(s)'
  },
  {
    featureName: 'EAX-OVERLAY-TWAMP-HS',
    displayName: 'Overlays/UI for Hub and Spoke Setup of PM flows',
    description: 'enables mass/bulk edit and easy setup of PM flows via UI (Hub and Spoke)'
  },
  {
    featureName: 'EAX-REG-VPMA-L',
    displayName: 'Number of vPMA-L',
    description:
      '(incremental) number of concurrent vPMA-L agents that can register with the controller/collector (each agent 2000 TWAMP flows or 500 Y.1731 streams as Initiator)'
  },
  {
    featureName: 'EAX-TRUESPEED-NSC',
    displayName: 'TrueSpeed NSC',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for NSC as test point(s)'
  },
  {
    featureName: 'EAX-IPV6',
    displayName: 'IPv6',
    description: 'enables IPv6 support on controller/collector and test agents'
  },
  {
    featureName: 'EAX-HTTP-FTP-MA',
    displayName: 'HTTP and FTP',
    description:
      'enables HTTP and FTP test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-PING-TRACERT-MA',
    displayName: 'PING, TRACE ROUTE',
    description:
      'enables PING and TRACE ROUTE test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-REG-NSC',
    displayName: 'Number of NSC',
    description: '(incremental) number of NSC registered to inventory.'
  },
  {
    featureName: 'EAX-UDP-NSC',
    displayName: 'UDP NSC',
    description: 'enables UDP test feature(s) on controller/collector for NSC as test point(s)'
  },
  {
    featureName: 'EAX-VOIP-MA',
    displayName: 'VOIP',
    description:
      'enables VOIP test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-BGP',
    displayName: 'BGP',
    description: 'enables BGP functionality on test agents'
  },
  {
    featureName: 'EAX-Y1564-QT600',
    displayName: 'Y1564 QT600',
    description:
      'enables Y1564 test feature(s) on controller/collector for QT600-10 as test point(s)'
  },
  {
    featureName: 'EAX-VOIP-NSC',
    displayName: 'VOIP NSC',
    description: 'enables VOIP test feature(s) on controller/collector for NSC as test point(s)'
  },
  {
    featureName: 'EAX-HTTP-FTP-NSC',
    displayName: 'HTTP and FTP NSC',
    description:
      'enables HTTP and FTP test feature(s) on controller/collector for NSC as test point(s)'
  },
  {
    featureName: 'EAX-PING-TRACERT-NSC',
    displayName: 'PING and TRACE ROUTE NSC',
    description:
      'enables PING and TRACE ROUTE test feature(s) on controller/collector for NSC as test point(s)'
  },
  {
    featureName: 'EAX-TRUESPEED-PC-TC',
    displayName: 'TrueSpeed Light PC Client',
    description:
      'enables TrueSpeed Light test feature(s) on controller/collector for PC SW client as test point(s)'
  },
  {
    featureName: 'EAX-Y1564-JMEP',
    displayName: 'Y1564 JMEP',
    description: 'enables Y1564 test feature(s) on controller/collector for JMEP as test point(s)'
  },
  {
    featureName: 'EAX-TWAMP-JMEP',
    displayName: 'TWAMP JMEP',
    description: 'enables TWAMP PM feature(s) on controller/collector for JMEP as test point(s)'
  },
  {
    featureName: 'EAX-REG-JMEP-10G',
    displayName: 'Number of 10G JMEP',
    description: '(incremental) number of 10G JMEP registered to inventory'
  },
  {
    featureName: 'EAX-REG-JMEP-1G',
    displayName: 'Number of 1G JMEP',
    description: '(incremental) number of 1G JMEP registered to inventory'
  },
  {
    featureName: 'EAX-REG-ESAM',
    displayName: 'Number of ESAM',
    description: '(incremental) number of ESAM registered to inventory'
  },
  {
    featureName: 'EAX-RFC2544-QT600',
    displayName: 'RFC2544 QT600',
    description:
      'enables RFC2544 test feature(s) on controller/collector for QT600-10 as test point(s)'
  },
  {
    featureName: 'EAX-RESTCONF',
    displayName: 'RESTCONF',
    description: 'enables RESTCONF northbound interface'
  },
  {
    featureName: 'EAX-SYSLOG',
    displayName: 'Syslog',
    description: 'enables export of log messages to syslog server'
  },
  {
    featureName: 'EAX-RADIUS',
    displayName: 'RADIUS',
    description: 'enables RADIUS authentication/authorization support on controller/collector'
  },
  {
    featureName: 'EAX-TMON-MEP',
    displayName: 'Traffic Monitoring JMEP',
    description: 'enables traffic monitoring on JMEP'
  },
  {
    featureName: 'EAX-RFC2544-TBERD-MTS',
    displayName: 'RFC2544 MTS TBERD',
    description:
      'enables RFC2544 test feature(s) on controller/collector for TBERD/MTS as test point(s)'
  },
  {
    featureName: 'EAX-TRUESPEED-RF-JMEP',
    displayName: 'TrueSpeed Reflector JMEP',
    description: 'enables L4 RFC6349 / TrueSpeed Reflector feature on JMEP'
  },
  {
    featureName: 'EAX-GEO-REDUNDANCY',
    displayName: 'Geographic Redundancy',
    description: 'enables controller/collector to operate in geo redundant mode'
  },
  {
    featureName: 'EAX-OPENID',
    displayName: 'OpenID',
    description: 'enables OpenID authentication/authorization support on controller/collector'
  },
  {
    featureName: 'EAX-SONET-DS1-MAP2100',
    displayName: 'SONET DS1 BERT MAP-2100',
    description:
      'enables L1 BERT test feature for SONET DS1 on controller/collector for MAP-2100 as test point'
  },
  {
    featureName: 'EAX-TRUESPEED-TCP-JMEP',
    displayName: 'TrueSpeed Initiator JMEP',
    description: 'enables L4 RFC6349 / TrueSpeed Initiator feature on JMEP'
  },
  {
    featureName: 'EAX-BERT-JMEP',
    displayName: 'BERT JMEP',
    description: 'FUSION - license to support L2/L3 BERT Testing on JMEP'
  },
  {
    featureName: 'EAX-SCHED-Y1564',
    displayName: 'Schedule Y.1564',
    description: 'enable scheduling of Y.1564 tests'
  },
  {
    featureName: 'EAX-SCHED-RFC2544',
    displayName: 'Schedule RFC2544',
    description: 'enable scheduling of RFC2544 tests'
  },
  {
    featureName: 'EAX-SCHED-UDP',
    displayName: 'Schedule UDP',
    description: 'enable scheduling of UDP tests'
  },
  {
    featureName: 'EAX-SCHED-TRUESPEED',
    displayName: 'Schedule TrueSpeed',
    description: 'enable scheduling of TRUESPEED tests'
  },
  {
    featureName: 'EAX-SCHED-HTTP-FTP',
    displayName: 'Schedule HTTP and FTP',
    description: 'enable scheduling of Internet Throughput tests'
  },
  {
    featureName: 'EAX-SCHED-VOIP',
    displayName: 'Schedule VOIP',
    description: 'enable scheduling of VOIP tests'
  },
  {
    featureName: 'EAX-SCHED-PING-TRACERT',
    displayName: 'Schedule TRACE ROUTE',
    description: 'enable scheduling of service tests'
  },
  {
    featureName: 'EAX-SCHED-MULTISTEP',
    displayName: 'Schedule Multistep Web',
    description: 'enable scheduling of multistep web tests'
  },
  {
    featureName: 'EAX-MULTISTEP-WEB-MA',
    displayName: 'Schedule Multistep Web MA',
    description: 'enable multistep web testing for virtual agent as test point(s)'
  },
  {
    featureName: 'EAX-REG-1PT',
    displayName: 'Registration Points',
    description: 'Registration points for registering SW agents'
  },
  {
    featureName: 'EAX-VIDEO-MA',
    displayName: 'VIDEO',
    description:
      'enables VIDEO test feature(s) on controller/collector for virtual test agents as test point(s)'
  },
  {
    featureName: 'EAX-ANALYTICS-PM-DASHBD',
    displayName: 'FUSION Data Analytics',
    description: 'enable PM Dashboard'
  },
  {
    featureName: 'EAX-TRUESPEED-ONXF',
    displayName: 'TrueSpeed ONXFIBER',
    description:
      'enables L4 RFC6349 / TrueSpeed test feature(s) on controller/collector for ONXF series as test point(s)'
  }
];
